import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { AttachIcon } from "components";
import { AttachmentDrawer } from "shared/features/attachment";
import React, { useState } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { getAttachmentData, setAttachmentData } from "../store/newTicketStore";

export const TicketAttachmentButton = () => {
  const theme = useTheme();
  const [isAttachmentModalOpen, setIsAttachmentModalOpen] = useState(false);
  // const [attachmentData, setAttachmentData] = useState<any>([]);
  const setAttachments = useSetAtom(setAttachmentData);
  const attachmentData = useAtomValue(getAttachmentData);
  return (
    <Box sx={{ position: "relative" }}>
      {attachmentData && attachmentData.uiData?.length > 0 && (
        <Box
          width={"20px"}
          height={"16px"}
          bgcolor={"red"}
          sx={{
            position: "absolute",
            top: 0,
            right: "2px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px",
            zIndex: 2,
          }}
        >
          <Typography variant="caption-3" color="#FFF">
            {attachmentData?.uiData.length}
          </Typography>
        </Box>
      )}
      <IconButton onClick={() => setIsAttachmentModalOpen(true)}>
        <AttachIcon htmlColor={theme.palette.purple.main} />
      </IconButton>
      {isAttachmentModalOpen && (
        <AttachmentDrawer
          serviceType="ticket"
          attachmentType="general"
          open={isAttachmentModalOpen}
          onClose={() => setIsAttachmentModalOpen(false)}
          attachmentData={attachmentData?.uiData}
          onSubmit={(data) => {
            setAttachments(data);
          }}
        />
      )}
    </Box>
  );
};
